<div class="rider-mobility-profile-wrapper">
  <div id="rider-mobility-profile" class="rider-mobility-profile">
    <div class="last-updated-date flex-row">
      <div class="flex-col">
        <div id="last-updated-header" class="last-updated-date-header">Last updated:</div>
      </div>
      <div class="flex-col">
        <div id="last-updated-content" class="last-updated-date-content">
          {{ mobilityProfileDetail?.modifiedDate | date : 'MM/dd/yyyy' }}
        </div>
      </div>
    </div>
    <div class="rider-mobility-profile-content flex-row">
      <div *ngFor="let mobilityProfileSection of mobilityProfileSections; let i = index" class="mobility-section flex-col">
        <app-checkbox-form-group
          [checkboxGroup]="mobilityProfileSection"
          [showValidationErrors]="showValidationErrors"
          [disableFormSelection]="!hasEditPermission"
          (formStatusChanged)="onMobilityProfileChanged(i, $event)"
        ></app-checkbox-form-group>
      </div>
    </div>
  </div>

  <div *ngIf="hasEditPermission" class="button-container">
    <afp-button [disabled]="!isProfileDirty || disableFormSubmitButtons" (click)="handleDiscardChanges()">Discard Changes</afp-button>
    <afp-button
      [disabled]="(!isProfileDirty && !mobilityProfileDetail?.verificationNeeded) || disableFormSubmitButtons"
      variant="primary"
      (click)="handleSaveChanges()"
    >
      {{ mobilityProfileDetail?.verificationNeeded ? 'Verify Profile' : 'Save Changes' }}
    </afp-button>
  </div>
</div>
